<mat-card appearance="outlined" class="cardBackground">
  <app-snackbar-content-layout>
    <app-snackbar-header-layout>
      <mat-card-title class="titleContainer"> {{ "MAIN_APP_DASHBOARD.notizen" | translate }}</mat-card-title>
      <button
        mat-mini-fab
        class="fabButton"
        color="primary"
        (click)="closeSnackbar()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
    </app-snackbar-header-layout>

    <mat-list *ngFor="let notiz of noteList; let first = first">
      <ng-container *ngIf="first">
        <mat-list-item class="listItem" >
          <div matListItemTitle>{{notiz.title}}</div>
          <div matListItemTitle>{{ notiz.notiz }}</div>
          <app-snackbar-header-layout>
            <div matListItemLine>{{ formatDate(notiz.datum) }}{{ "MAIN_APP_DASHBOARD.uhr" | translate }}</div>
            <button mat-mini-fab color="primary" (click)="showNotizDetail(notiz)" class="fabButton">
              <mat-icon>edit</mat-icon>
            </button>
          </app-snackbar-header-layout>
        </mat-list-item>
        <mat-divider></mat-divider>
        <div class="fabButtonContainer">
          <button mat-flat-button (click)="showNotizList()" class="flatButton">{{"MAIN_APP_DASHBOARD.alleNotizenAnzeigen" | translate}}</button>
        </div>
      </ng-container>
      
      
    </mat-list>
  </app-snackbar-content-layout>
</mat-card>
